















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { PortalLayout } from '@/layouts/portal';
import Login from './components/login.vue';

/** 首页 */
@Component({ components: { PortalLayout, Login } })
export default class Index extends Vue {
  mounted() {}
}
